import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Coloured "tile" used at the top of each dashboard.
 * `accent` is a colour string (CSS) — used for the right border + heading,
 * mirroring the `border-right: 4px solid <colour>` pattern used in the
 * original Django/Taskose template (templates/task_new/index.html).
 *
 * Default accent is the brand indigo (#7980ff) so the stat row blends
 * with the rest of the theme out of the box.
 *
 * The numeric value sits at the **top-right** of the tile so pending
 * task counts and complaint numbers are readable without scanning the
 * centre of each card.
 *
 * Pass `to` to make the whole tile a router link — dashboards show a
 * count, and the natural next question is "which records are those?".
 * Linking the tile answers it in one click instead of making the user
 * find the matching list page and re-apply the filter by hand.  The
 * caller decides the destination (usually a list page with the same
 * filter pre-applied), so a tile never navigates somewhere that shows
 * a different set of rows than the number it displays.
 */
export default function StatCard({
  label, value, weekly, accent = '#7980ff', to, title,
}) {
  const inner = (
    <>
      <div className="ty-stat__row">
        <div className="ty-stat__label">{label}</div>
        <div className="ty-stat__value" style={{ color: accent }}>{value ?? 0}</div>
      </div>
      {weekly !== undefined && (
        <div className="ty-stat__weekly">
          Weekly: <strong>{weekly} ↑</strong>
        </div>
      )}
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className="ty-stat ty-stat--link"
        style={{ borderRightColor: accent }}
        title={title || `View ${label}`}
      >
        {inner}
      </Link>
    );
  }

  return (
    <div className="ty-stat" style={{ borderRightColor: accent }}>
      {inner}
    </div>
  );
}
